import React, { Component } from "react";
import { observable } from "mobx";
import { AppConstants, Types } from "../../../common/APIConstants";
import moment from "moment";
import _ from "lodash";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import SmartSelectClearable from "../../../common/SmartSelectClearable";
import { NumericCellEditorAllowNegative } from "../../../common/NumericCellEditorAllowNegative";
import {
  DateFormatter,
  DateTimeFormatter,
} from "../../../common/DateFormatterWithZone";
import { DecimalFormatterWithNegative } from "../../../common/NumberFormatter";
import { Datepicker } from "../../../common/Datepicker";
import GainLossTransactionAPI from "../services/gainloss-transaction-screen-service";
import GainLossSmartSelect from "../component/gainloss-smartSelect";
import { ALL_DISTRICT_OR_DIVISION } from "../../../constants/common";
class GainLossTransactionScreenStore {
  @observable selectedJurisdiction = null;
  @observable selectedDivision = null;
  @observable selectedProductionMonth = null;
  @observable setColumnDefinitions = null;
  @observable screenColumnDefinitions = {
    GainLossTransactionScreen: [],
  };
  @observable hasScreenData = false;
  @observable screenRowData = {
    TransactionData: [],
  };
  @observable rowData = [];
  @observable selectedData = [];
  @observable districtData = [];
  @observable productionMonthData = [];
  @observable showAuditPopUp = false;
  @observable headerNames = [];
  @observable auditData = [];
  @observable fieldNames = [];
  setSelectedJurisdiction = (jurisdiction) =>
    (this.selectedJurisdiction = jurisdiction);

  setSelectedDivision = (division) => (this.selectedDivision = division);
  setSelectedProductionMonth = (productionMonth) =>
    (this.selectedProductionMonth = productionMonth);

  setAuditPopUp = (value) => (this.showAuditPopUp = value);

  getColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      [
        "district",
        "type",
        "uom",
        "productionDate",
        "system",
        "subSystem",
        "product",
      ].includes(column.name)
        ? gridColumns.push({
            field: column.name,
            headerName: column.title,
            type: "text",
            hide: column.hidden,
            pinned: "left",
            width: column.width ? column.width : 200,
            keyCreator: (params) => {
              return this.getValueFomatter(params, column, screen)
                ? this.getValueFomatter(params, column, screen)
                : params.value;
            },
            cellClassRules: {
              "grid-cell-custom": (params) => {
                return params.data ? true : false;
              },
            },
            cellRenderer: this.getCellRenderer(column),
            cellEditor: this.getCellEditor(column),
            cellEditorParams: (params) =>
              this.getCellEditorParams(column, params),
            valueFormatter: (params) => {
              return this.getValueFomatter(params, column, screen);
            },
          })
        : gridColumns.push({
            field: column.name,
            headerName: column.title,
            filterParams: {
              comparator: (a, b) => {
                const valA = parseInt(a);
                const valB = parseInt(b);
                if (valA === valB) return 0;
                return valA > valB ? 1 : -1;
              },
            },
            type: "text",
            hide: column.hidden,
            width: column.width ? column.width : 200,
            keyCreator: (params) => {
              return this.getValueFomatter(params, column, screen)
                ? this.getValueFomatter(params, column, screen)
                : params.value;
            },
            cellClassRules: {
              "grid-cell-custom": (params) => {
                return params.data ? true : false;
              },
            },
            cellRenderer: this.getCellRenderer(column),
            cellEditor: this.getCellEditor(column),
            cellEditorParams: (params) =>
              this.getCellEditorParams(column, params),
            valueFormatter: (params) => {
              return this.getValueFomatter(params, column, screen);
            },
          });
    });
    return gridColumns;
  };

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return "SmartSelectClearable";
      case Types.NUMBER:
        return "NumericCellEditor";
      case Types.datetime:
        return "dateTimeFormatter";
    }
  }
  getCellEditorParams(column, params) {
    switch (column.type) {
      case Types.DROPDOWN:
        if (column.name === "dataConfidence")
          return {
            values: [
              { label: "1 - Final", value: "1 - Final" },
              {
                label: "2 - Unlikely to Change",
                value: "2 - Unlikely to Change",
              },
              { label: "3 - Preliminary", value: "3 - Preliminary" },
            ],
          };
        else
          return {
            values: column.refLookupData?.lookupValues.values,
            isPopup: true,
          };
    }
  }

  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return "booleanCellEditor";
      case Types.DATETIME:
        return "dateTimeFormatter";
      case Types.DECIMAL:
        return "decimalFormatter";
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(
          column.refLookupData.lookupValues,
          params.value
        );
      }
      switch (column.type) {
        case Types.DATETIME:
          return "dateTimeFormatter";
      }
    }
  }

  lookupValue(mappings, key) {
    if (
      !mappings ||
      mappings === "undefined" ||
      !mappings.values.find((item) => item.value == key)
    )
      return null;
    else {
      let label = mappings.values.find((item) => item.value == key).label;
      return label;
    }
  }

  setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;
        this.screenColumnDefinitions[child.screen.name] = [];
        this.screenColumnDefinitions[child.screen.name] =
          this.getColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available for selected date")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  gridOptions = {
    rowSelection: "multiple",
    singleClickEdit: true,
    pagination: false,
    stopEditingWhenGridLosesFocus: true,
    autoSizeAllColumns: true,
    floatingFilter: true,
    enableRangeSelection: true,
    rowGroupPanelShow: "always",
    suppressContextMenu: true,
    getRowStyle: this.getRowStyleScheduled,
    statusBar: {
      statusPanels: [
        {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left",
        },
        {
          statusPanel: "agAggregationComponent",
          statusPanelParams: {
            aggFuncs: ["avg", "count", "min", "max", "sum"],
          },
        },
      ],
    },
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
      ],
      showToolPanel: false,
    },

    defaultColDef: {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      filter: true,
      resizable: true,
      editable: this.IsEditable.bind(this),
      cellStyle: (param) => {
        if (this.IsEditable(param) === false)
          return { backgroundColor: "LightGray" };
        if (this.IsOverflow(param) === true) return { overflow: "visible" };
      },
    },
    frameworkComponents: {
      SmartSelectClearable: GainLossSmartSelect,
      booleanCellEditor: CheckboxRenderer,
      NumericCellEditor: NumericCellEditorAllowNegative,
      dateFormatter: DateFormatter,
      dateTimeFormatter: DateTimeFormatter,
      datePicker: Datepicker,
      decimalFormatter: DecimalFormatterWithNegative,
    },
    suppressPropertyNamesCheck: true,
    suppressNoRowsOverlay: true,
    sizeColumnsToFit: true,
  };

  getScreenData = async (
    currentScreen,
    jurisdiction,
    division,
    productionMonth,
    CommonStore
  ) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    this.screenRowData.TransactionData = [];
    this.rowData = [];
    try {
      let requestObj = {
        Jurisdiction: jurisdiction,
        Division: division,
        ProductionMonth: productionMonth,
      };

      const { data } =
        jurisdiction == "Plains - North"
          ? await GainLossTransactionAPI.getPMCTransactionScreenData(requestObj)
          : await GainLossTransactionAPI.getPAATransactionScreenData(
              requestObj
            );
      this.formatProductionDate(data);
      this.formatDate(data);
      this.screenRowData.TransactionData = data;
      this.rowData = data;
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Data not available for selected jurisdiction and division"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  formatDate = (data) => {
    Object.values(data).forEach((value) => {
      if (value.sourceSystemLoadDateTime == null)
        value.sourceSystemLoadDateTime = "";
      else {
        value.sourceSystemLoadDateTime = new Date(
          value.sourceSystemLoadDateTime
        ).toLocaleString("en-US", {
          timeZone: "America/Denver",
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour12: true,
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      if (value.lastSavedDateTime == null) value.lastSavedDateTime = "";
      else {
        value.lastSavedDateTime = new Date(
          value.lastSavedDateTime
        ).toLocaleString("en-US", {
          timeZone: "America/Denver",
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour12: true,
          hour: "2-digit",
          minute: "2-digit",
        });
      }
    });
  };

  formatProductionDate = (data) => {
    Object.values(data).forEach((value) => {
      value.productionDate =
        value.productionDate.split("-")[1] +
        "-" +
        value.productionDate.split("-")[0];
    });
  };

  formatColumnByJurisdiction = (jurisdiction) => {
    const data = this.screenColumnDefinitions.GainLossTransactionScreen;
    this.headerNames = [];
    this.fieldNames = [];
    Object.values(data).forEach((value) => {
      if (
        ![
          "district",
          "type",
          "uom",
          "productionDate",
          "system",
          "product",
          "throughput",
          "gainLoss",
          "sourceSystemLoadDateTime",
          "lastSavedBy",
          "lastSavedDateTime",
        ].includes(value.field)
      ) {
        value.hide = jurisdiction == "Plains - South" ? true : false;
      }
      if (value.field == "isLoadedFromSourceSystem") value.hide = true;
      if (value.field == "isPGAS") value.hide = true;
      if (value.field == "district") {
        value.headerName =
          jurisdiction == "Plains - South" ? "Division" : "District";
      }
    });
    Object.values(data).forEach((value) => {
      if (value.hide == false) {
        this.headerNames.push(value.headerName);
        this.fieldNames.push(value.field);
      }
    });
  };

  formatSavedData = () => {
    return this.selectedData.filter(
      (object, index) =>
        index ===
        this.selectedData.findIndex(
          (obj) => JSON.stringify(obj) === JSON.stringify(object)
        )
    );
  };

  saveData = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      this.selectedJurisdiction.value == "Plains - North"
        ? await GainLossTransactionAPI.updatePMCTransactionScreenData(
            this.formatSavedData()
          )
        : await GainLossTransactionAPI.updatePAATransactionScreenData(
            this.formatSavedData()
          );
      this.selectedData = [];
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Error While Updating")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  refreshData = (CommonStore) => {
    CommonStore.toggleLoader();
    this.selectedData = [];
    CommonStore.toggleLoader();
  };

  exportToExcel = (parentScreenName) => {
    let params = {
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      shouldRowBeSkipped: false,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      fileName: parentScreenName,
    };
    var today = new Date();
    const formattedDate = moment(today).format("YYYYMMDDhhmmss");
    const currentSheet = parentScreenName;
    let fileNameExcelExport =
      currentSheet + "_Export_All_" + formattedDate + "";

    this.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
    });
  };

  setDistrictData = async (CommonStore, jurisdiction) => {
    if (!jurisdiction) return;
    CommonStore.toggleLoader();
    try {
      this.districtData = [];
      const requestData = {
        jurisdiction: jurisdiction,
        entityType: "Division/District",
      };
      const response = await GainLossTransactionAPI.getEntityList(requestData);
      const district = response?.data?.map((item) => ({
        ...item,
        isActive: item.isActive ? "Active" : "Inactive",
      }));
      Object.values(district).forEach((value) => {
        if (value.isActive == "Active")
          this.districtData.push({
            value: value.entityName,
            label: value.entityName,
          });
      });
      // option "All" for district/division
      if(this.districtData.length){
        this.districtData.unshift(ALL_DISTRICT_OR_DIVISION)
      }
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  setProductionMonths = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      this.productionMonthData = [];
      const { data } = await GainLossTransactionAPI.getProductionMonths();
      Object.values(data).forEach((value) => {
        if (value.isActive === true) {
          this.selectedProductionMonth = {
            value: value.value,
            label: value.label,
          };
        }
      });
      Object.values(data).forEach((value) => {
        this.productionMonthData.push({
          value: value.value,
          label: value.label,
        });
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  IsOverflow(params) {
    if (params.colDef.field === "dataConfidence") {
      return true;
    } else return false;
  }
  IsEditable(params) {
    if (["throughput", "gainLoss"].includes(params.colDef.field)) {
      if (
        params.data.isLoadedFromSourceSystem === false ||
        params.data.isLoadedFromSourceSystem === null
      ) {
        return true;
      } else if (params.data.isLoadedFromSourceSystem === true) {
        return false;
      }
    } else if (["bsw"].includes(params.colDef.field)) {
      if (params.data.isPGAS === true) return false;
      else if (params.data.isPGAS === false || params.data.isPGAS === null)
        return true;
    } else if (
      [
        "district",
        "type",
        "uom",
        "productionDate",
        "system",
        "subSystem",
        "product",
        "sourceSystemLoadDateTime",
        "lastSavedBy",
        "lastSavedDateTime",
        "isLoadedFromSourceSystem",
      ].includes(params.colDef.field)
    )
      return false;
    else return true;
  }

  getAuditData = async (CommonStore, requestData) => {
    CommonStore.toggleLoader();
    this.auditData = [];
    try {
      let requestObj = {
        Jurisdiction: this.selectedJurisdiction.value,
        System: requestData.system,
        SubSystem: requestData.subSystem,
        Product: requestData.product,
        District: requestData.district,
        Type: requestData.type,
        UOM: requestData.uom,
        ProductionDate: requestData.productionDate,
      };

      const { data } = await GainLossTransactionAPI.getTransactionAuditData(
        requestObj
      );

      this.auditData = data;
      CommonStore.toggleLoader();
      return data;
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Audit Data not available for selected row"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  FetchEABS = async (toEmailAddress) => {
    try {
      const requestData = {
        ToEmailAddress: toEmailAddress,
        selectedProductionMonth: this.selectedProductionMonth.value,
      };
      const response = await GainLossTransactionAPI.FetchEABS(requestData);
      if (response.status == 200)
        window.toastr.success(
          AppConstants.GAINLOSS_EABS_INTEGRATION +
            ` for Production Month ${this.selectedProductionMonth.label}. ` +
            AppConstants.GAINLOSS_EMAIL
        );
      else window.toastr.error(AppConstants.GAINLOSS_EABS_INTEGRATION_FAIL);
    } catch (error) {
      window.toastr.error(AppConstants.GAINLOSS_EABS_INTEGRATION_FAIL);
    }
  };

  FetchFBS = async (toEmailAddress) => {
    try {
      const requestData = {
        ToEmailAddress: toEmailAddress,
        selectedProductionMonth: this.selectedProductionMonth.value,
      };
      const response = await GainLossTransactionAPI.FetchFBS(requestData);
      if (response.status == 200)
        window.toastr.success(
          AppConstants.GAINLOSS_FBS_INTEGRATION +
            ` for Production Month ${this.selectedProductionMonth.label}. ` +
            AppConstants.GAINLOSS_EMAIL
        );
      else window.toastr.error(AppConstants.GAINLOSS_FBS_INTEGRATION_FAIL);
    } catch (error) {
      window.toastr.error(AppConstants.GAINLOSS_FBS_INTEGRATION_FAIL);
    }
  };

  FetchVMAC = async (toEmailAddress, isVmacPPA) => {
    const {
      GAINLOSS_VMAC_INTEGRATION,
      GAINLOSS_VMAC_PPA_INTEGRATION,
      GAINLOSS_VMAC_INTEGRATION_FAIL,
      GAINLOSS_VMAC_PPA_INTEGRATION_FAIL
    } = AppConstants
    const successMsgInitial = isVmacPPA ? GAINLOSS_VMAC_PPA_INTEGRATION : GAINLOSS_VMAC_INTEGRATION
    const failureMsg = isVmacPPA ? GAINLOSS_VMAC_PPA_INTEGRATION_FAIL : GAINLOSS_VMAC_INTEGRATION_FAIL

    try {
      const requestData = {
        ToEmailAddress: toEmailAddress,
        selectedProductionMonth: this.selectedProductionMonth.value
      };

      if (isVmacPPA) {
        requestData.RefreshTypeVMACS = "ppa"
      }

      const response = await GainLossTransactionAPI.FetchVMAC(requestData);
      if (response.status == 200)
        window.toastr.success(
          successMsgInitial +
          ` for Production Month ${this.selectedProductionMonth.label}. ` +
          AppConstants.GAINLOSS_EMAIL
        );
      else window.toastr.error(failureMsg);
    } catch (error) {
      window.toastr.error(failureMsg);
    }
  };

  FetchFlowCal = async (toEmailAddress,userName) => {
    try {
      const requestData = {
        UserMailID: toEmailAddress,
        UserName: userName,
        ProdYearMonth: this.selectedProductionMonth.value,
      };
      const response = await GainLossTransactionAPI.FetchFlowCal(requestData);
      if (response.status == 200)
        window.toastr.success(
          AppConstants.GAINLOSS_FLOWCAL_INTEGRATION +
          ` for Production Month ${this.selectedProductionMonth.label}. ` +
          AppConstants.GAINLOSS_EMAIL
        );
      else window.toastr.error(AppConstants.GAINLOSS_FLOWCAL_INTEGRATION_FAIL);
    } catch (error) {
      window.toastr.error(AppConstants.GAINLOSS_FLOWCAL_INTEGRATION_FAIL);
    }
  };

  FetchHW = async (toEmailAddress) => {
    try {
      const requestData = {
        ToEmailAddress: toEmailAddress,
        selectedProductionMonth: this.selectedProductionMonth.value,
      };
      const response = await GainLossTransactionAPI.FetchHW(requestData);
      if (response.status == 200)
        window.toastr.success(
          AppConstants.GAINLOSS_HIGHWIRE_INTEGRATION +
            ` for Production Month ${this.selectedProductionMonth.label}. ` +
            AppConstants.GAINLOSS_EMAIL
        );
      else window.toastr.error(AppConstants.GAINLOSS_HIGHWIRE_INTEGRATION_FAIL);
    } 
    catch (error) {
      const errorMessage = error.response ? error.response.data : AppConstants.GAINLOSS_HIGHWIRE_INTEGRATION_FAIL;
      window.toastr.error(errorMessage);      
    }
  };
}

export default new GainLossTransactionScreenStore();
